import { BpeConfigProvider } from './features/tenantConfig/BpeConfigProvider';
import { TenantContext, WithConfigs } from './features/tenantConfig/types';

export const bpeConfig = new BpeConfigProvider(
  window as WithConfigs,
  {
    MIXPANEL_ACCESS_TOKEN: process.env.MIXPANEL_ACCESS_TOKEN || undefined,
    GOOGLE_RECAPTCHA_SITE_KEY: process.env.GOOGLE_RECAPTCHA_SITE_KEY || undefined,
    LD_CLIENT_ID: process.env.LD_CLIENT_ID || undefined,
    LD_GLOBAL_CLIENT_ID: process.env.LD_GLOBAL_CLIENT_ID || undefined,
    MAPBOX_ACCESS_TOKEN: process.env.MAPBOX_ACCESS_TOKEN || undefined,
    SENTRY_DNS: process.env.SENTRY_DNS || undefined
  } as TenantContext,
  process.env.NODE_ENV === 'production'
);
